export default "__VITE_ASSET__BF6oq0_b__"